export { Speakerphone as default } from './Speakerphone';
